<template>
  <div class="product-item">
    <bg-intro :bg="bg" class="bg-wrapper">
      <div class="video-intro">
        <h2>渐进式图像压缩算法</h2>
        <p>
          突破高压缩比的语音图像编码和解码技术，设计了低延时的语音图像数据调度协议。500倍压缩率情况下，图像质量评价指标PSNR不低于20dB，且创新性实现了图像压缩的渐进传输方式。
        </p>
        <a class="btn-wrapper" href="#video">
          <div class="btn-content space-between">
            <img src="../../assets/product/play.svg" alt="play" />
            <span>点击视频了解</span>
          </div>
        </a>
      </div>
    </bg-intro>
    <div class="achievement">
      <div class="img-wrapper space-between">
        <img src="../../assets/product/zd.png" alt="重大专项" />
        <img src="../../assets/product/zhongda.webp" alt="中山大学" />
        <img src="../../assets/product/zdlogo.png" alt="中山大学" />
      </div>
      <h5><b>依托北斗重大专项应用推广与产业化项目</b></h5>
      <h5>中山大学CPNT Lab研发成功，成熟应用，稳定可靠</h5>
    </div>

    <div class="upload-wrapper">
      <div class="upload-content content-container">
        <h3>图片压缩</h3>
        <upload></upload>
      </div>
    </div>
    <div class="video-wrapper" id="video">
      <h3>演示视频</h3>
      <!-- <video controls width="1200">
        <source :src="`${baseUrl}/api/console/files/material/video/bd-short-msg-show-video.mp4`" type="video/mp4" />
      </video> -->
      <div class="video-wrapper">
        <iframe
          class="iframe-video"
          src="//player.bilibili.com/player.html?aid=686850174&bvid=BV1cU4y1C7XJ&cid=798323318&page=1&as_wide=0&danmaku=0"
          width="1200"
          height="744.34"
          scrolling="no"
          border="0"
          frameborder="no"
          framespacing="0"
          allowfullscreen="true"
        ></iframe>
      </div>
    </div>
    <highlight :highlightsData="highlightData"></highlight>
    <practice :practiceData="practiceData"></practice>

    <field :fieldData="fieldData" bg="#F6F7F8"></field>




    <div class="brief-wrapper">
      <h3>关键技术</h3>
      <brief :briefData="briefData[0]" :isReverse="true"></brief>
      <brief :briefData="briefData[1]" :isReverse="false"></brief>
      <brief :briefData="briefData[2]" :isReverse="true"></brief>
    </div>
    <product title="适用设备"></product>
    <beDevelop></beDevelop>
  </div>
</template>

<script>
import bgIntro from '@/components/common/product/bgIntro.vue';
import field from '@/components/common/solution/field.vue';
import highlight from '@/components/common/solution/highlight.vue';
import brief from '@/components/common/solution/brief.vue';
import product from '@/components/common/solution/product.vue';
import beDevelop from '@/components/common/beDevelop.vue';
import practice from '@/components/common/practice.vue';
import upload from './components/upload.vue';
import config from '@/config';
export default {
  metaInfo: {
    title: '渐进式图像压缩算法',
    meta: [
      {
        name: 'keywords',
        content: '窄带语音压缩,渐进式图像压缩算法,北斗收发语音,卫星语音通话',
      },
      {
        name: 'description',
        content:
          '突破高压缩比的语音图像编码和解码技术，设计了低延时的语音图像数据调度协议。在500倍压缩率情况下，图像质量评价指标PSNR不低于20dB，且创新性实现了图像压缩的渐进传输方式。',
      },
    ],
  },
  data() {
    return {
      baseUrl: config.baseUrl,
      bg: require('../../assets/product/pic.png'),
      fieldData: {
        fieldTitle: '应用领域',
        items: [
          {
            id: 'field1',
            imgSrc: require('../../assets/product/xuqiu1.webp'),
            intro1: '窄宽通信卫星通信容量有限',
            intro2: '只能发送文字内容',
          },
          {
            id: 'field2',
            imgSrc: require('../../assets/product/xuqiu2.webp'),
            intro1: '应急通信时文字输入效率低',
            intro2: '无法满足实际应用需求',
          },
          {
            id: 'field3',
            imgSrc: require('../../assets/product/xuqiu3.webp'),
            intro1: '企事业单位自研语音压缩技术耗时',
            intro2: '耗力，效果不佳',
          },
        ],
      },
      highlightData: {
        title: '服务指标',
        items: [
          {
            id: 'h1',
            title: '高压缩比',
            intro:
              '创新性提出并实现了分包传输情况下图像渐进式显示技术。最优化利用宝贵的信道带宽，实现窄带宽下抗误码、高压缩比图像传输。',
            imgSrc: require('../../assets/product/fuwu1.webp'),
            color: '#EFA65E',
          },
          {
            id: 'h2',
            title: '高质量',
            intro: '实现图像数据的渐进式数据分包传输协议，满足用户实际使用中的图像质量要求。',
            imgSrc: require('../../assets/product/fuwu2.webp'),
            color: '#63B59F',
          },
          {
            id: 'h3',
            title: '高时效',
            intro:
              '封装协议中包含帧头和帧计数信息，可支持应用层数据包重传，最优化利用宝贵的信道带宽，满足用户对图像数据获取的实时性。',
            imgSrc: require('../../assets/product/fuwu3.webp'),
            color: '#4173FB',
          },
        ],
      },
      briefData: [
        {
          title: '图像压缩渐进传输技术',
          imgSrc: require('../../assets/product/guanjian21.webp'),
          introItems: [
            {
              id: 'intro1',
              // subtitle: '平板应用app支持全国卫星/标准离线地图下载，储存在平板电脑本地；  ',
              intro:
                '基于RDSS传输协议下图像压缩数据分包重传策略，创新性提出并实现了分包传输情况下图像渐进式显示技术，最优化利用宝贵的信道带宽，实现窄宽带下抗误码、高压缩比图像传输。',
            },
          ],
        },
        {
          title: '窄带宽下高压缩比图像传输策略优化',
          imgSrc: require('../../assets/product/guanjian22.webp'),
          introItems: [
            {
              id: 'intro1',
              // subtitle: '复高斯混合模型估计时频掩蔽和方向矢量',
              intro:
                '采用自适应高压缩比策略，压缩后图像数据按渐进顺序进行二次封装，封装协议中包含帧头和帧计数信息，可支持应用层数据包重传，最优化利用宝贵的信道带宽。',
              // intro: '北斗船载终端定时5分钟/次（可调）向后台上报终端位置信息',
            },
          ],
        },
        {
          title: '抗长时延的语音图像传输协议',
          imgSrc: require('../../assets/product/guanjian23.webp'),
          introItems: [
            {
              id: 'intro1',
              intro:
                '发送端在正常的报文序列中合理加入冗余编码报文，接收端通过这些编码报文解码产生丢失的原始报文，从而避免了丢报重传所带来的时间损耗。',
              // intro: '北斗船载终端定时5分钟/次（可调）向后台上报终端位置信息',
            },
          ],
        },
      ],
      practiceData: {
        title: '应用场景',
        items: [
          {
            id: '应急救援',
            intro: '应急救援',
            imgSrc: require('../../assets/product/yingyong21.webp'),
          },
          {
            id: '户外探险',
            intro: '户外探险',
            imgSrc: require('../../assets/product/yingyong22.webp'),
          },
          {
            id: '地址勘察',
            intro: '地址勘察',
            imgSrc: require('../../assets/product/yingyong23.webp'),
          },
          {
            id: '施工巡检',
            intro: '施工巡检',
            imgSrc: require('../../assets/product/yingyong24.webp'),
          },
        ],
      },
    };
  },

  components: {
    bgIntro,
    field,
    highlight,
    brief,
    product,
    beDevelop,
    practice,
    upload,
  },
};
</script>

<style lang="scss" scoped>
.product-item {
  width: 100%;
  overflow: hidden;
  .upload-wrapper {
    background-color: #f2f2f2;
    padding: 30px 0;
  }
  .achievement {
    margin-top: 50px;
    margin-bottom: 50px;
    .img-wrapper {
      width: 600px;
      margin: 0 auto;
      img {
        max-width: 200px;
      }
    }
    h5 {
      text-align: center;
      font-size: 16px;
      font-weight: 400;
      color: #0d0e24;
      line-height: 30px;
      margin-top: 20px;
    }
  }

  .video-wrapper {
    width: 1200px;
    margin: 50px auto;
    h3 {
      margin-bottom: 50px;
    }
    // video {
    //   text-align: center;
    // }
    // .video-wrapper {
    //   position: relative;
    //   margin-bottom: 1em;
    //   padding-bottom: 56.25%;
    //   height: 0;
    //   overflow: hidden;
    //   max-width: 100%;
    //   iframe,
    //   object,
    //   embed {
    //     position: absolute;
    //     top: 0;
    //     left: 0;
    //     width: 100%;
    //     height: 100%;
    //   }
    // }
  }

  .brief-wrapper {
    margin-top: 70px;
  }

  h3 {
    font-size: 28px;
    font-weight: 400;
    color: #0d0e24;
    text-align: center;
  }
}
</style>